<script>
  import { onMount } from "svelte"
  import fileTemplateState from "../../stores/fileTemplateJsonData"
  import cursorPosition from "../../stores/cursorPosition"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import notify from "../../../../../Script/notify"
  import { loadImage, drawChecked } from "../Script/loadImg"
  import axios from "axios"
  import { validateFile } from "../../../../Publish/BulkUpload/Script/bulkUpload"
  import QRCode from "qrcode"

  /**
   * @type {Object} The current operation being performed.
   */
  export let operation
  /**
   * @type {File} binded the sub image of the file being processed
   */
  let files
  /**
   * @type {Boolean} Indicates whether the content is currently loading used for upload subimage section
   */
  let loading = false

  let aspectRatio = 1
  let maintainAspectRatio = true
  // let maintainAspectRatio = operation.type == "qr"
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }
  $: operation.x = Math.floor(operation.x)
  $: changeInputY(operation.y)
  const changeInputY = (y) => {
    operation.inputY = Math.floor($fileTemplateState.baseImageInfo.height - operation.height - y)
  }

  // Reactively update errorX/errorY immediately when position or size changes
  $: {
    operation.errorX = operation.x < 0 || operation.x + operation.width > $fileTemplateState.baseImageInfo.width
    operation.errorY = operation.y < 0 || operation.y + operation.height > $fileTemplateState.baseImageInfo.height
  }

  const generateQR = async () => {
    try {
      let qrImage = await QRCode.toDataURL("https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592", {
        color: {
          light: operation.bgColor, // Fully transparent background
          dark: operation.color, // Black QR code
        },
      })

      operation.image = await loadImage(qrImage)
    } catch (error) {
      closeNotification.close()
      console.error(error)
      const info = "PAGE: File template editor\n EVENT: While generating sample QRCode"
      closeNotification = notify.danger(error, info)
    }
  }

  onMount(() => {
    if (operation.type == "qr") aspectRatio = 1
  })

  /**
   * @typedef {Object} invalidNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notification}
   */
  let invalidNotification = {
    close() {},
  }

  /**
   *Toggles the display of the upload section based on the dynamic operation state.
   * Updates the operation object accordingly.
   */
  const displayUploadSection = async () => {
    try {
      operation.uploadImage = true
      // console.log(operation, "ope")
      operation.src = drawChecked(operation.width, operation.height)
      operation.image = await loadImage(operation.src)
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor (Image Layer)\n EVENT: While displaying upload area for image upload"
      closeNotification = notify.danger(error, info)
    }
  }

  const handleImageUpload = async (files) => {
    if (files) {
      try {
        loading = true

        const MAX_FILE_SIZE = 2 * 1024 * 1024

        if (files[0].size > MAX_FILE_SIZE) throw "Maximum File Size exceeded"

        await validateFile(files[0])
        if (!operation.dynamic) {
          let imageFile = {
            file: files[0],
          }

          //updating stores
          operation.src = await storeImage(imageFile)
        } else {
          operation.src = URL.createObjectURL(files[0])
        }
        operation.image = await loadImage(operation.src)
        // operation.width = Math.floor(operation.image.naturalWidth)
        // operation.height = Math.floor(operation.image.naturalHeight)

        // console.log(operation.image.naturalWidth, operation.image.naturalHeight)

        operation.aspectRatio = operation.image.naturalWidth / operation.image.naturalHeight

        if (!operation.dynamic) {
          maintainAspectRatio = true
          aspectRatio = operation.aspectRatio

          if (operation.width >= operation.height) {
            operation.height = Math.floor(operation.width / aspectRatio)
          } else {
            operation.width = Math.floor(operation.height * aspectRatio)
          }
        }
        operation.uploadImage = false
      } catch (error) {
        const info = "PAGE: File template editor (Image Layer)\n EVENT: While validating and updating uploaded image"
        notify.danger(error, info)
        files = null
        operation.uploadImage = true
      } finally {
        loading = false
      }
    }
  }

  const storeImage = (imageFile) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.post(`/api/swagger/v2/templates/files/${$fileTemplateState.baseImageInfo.id}/image`, imageFile, {
          headers: {
            "x-access-token": $ApplicationState.token,
            "Content-Type": "multipart/form-data",
          },
        })
        //error checking while api call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        resolve(data.uri)
      } catch (error) {
        reject(error)
      }
    })
  }

  $: handleImageUpload(files)

  const moveCursor = () => {
    let id = operation.id
    $fileTemplateState.operations = $fileTemplateState.operations.map((operation) => {
      operation.move = false // Reset move for all operations
      if (operation.id === id) {
        // Center the cursor relative to the image
        $cursorPosition.x = operation.x + operation.width / 2
        $cursorPosition.y = $fileTemplateState.baseImageInfo.height - (operation.y + operation.height / 2)
        operation.move = true // Enable move for the selected operation
      }
      return operation
    })
  }

  $: if (operation.move) {
    // Center the image around the cursor while moving
    operation.x = $cursorPosition.x - operation.width / 2
    operation.y = $fileTemplateState.baseImageInfo.height - $cursorPosition.y - operation.height / 2
  }

  const preventKeys = (e) => {
    const KEYS_TO_PREVENT = ["-", "+", "e", "E"]
    if (KEYS_TO_PREVENT.includes(e.key)) e.preventDefault()
  }
</script>

<!-- delete modal press enter key -->
<svelte:window on:keydown />

<div class="w-[383px] space-y-3 rounded-md bg-[#292A2F] p-6 {operation.errorX || operation.errorY ? 'border-2 border-red-500' : ''} {operation.active ? 'border-2 border-blue-500' : ''}">
  {#if operation.type == "image"}
    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2 select-none text-sm font-bold text-gray-g00 {operation.attribute ? 'group-focus-within:text-extraBlue-500' : 'group-focus-within:text-red-500'}">NAME</div>
      <input
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        required
        type="text"
        bind:value={operation.attribute}
        class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none invalid:animate-shake focus:ring-2 focus:ring-extraBlue-500 invalid:focus:ring-red-500"
      />
    </div>
  {:else}
    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">NAME</div>
      <input readonly type="text" value={operation.attribute} class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none focus:ring-2 focus:ring-extraBlue-500" />
    </div>
  {/if}
  {#if operation.type == "image"}
    <div class="flex w-full items-center justify-between bg-transparent px-1 py-2">
      <div class="flex items-center gap-9">
        <div class="select-none text-sm font-bold text-gray-g00">TYPE</div>
        <button
          on:click={() => {
            operation.dynamic = false
            displayUploadSection()
          }}
          class="flex items-center gap-3"
        >
          <input checked={!operation.dynamic} type="radio" name="amount" value="STATIC" class="h-5 w-5" />
          <span class="text-sm text-white">STATIC</span>
        </button>
        <button
          on:click={() => {
            operation.dynamic = true
            displayUploadSection()
          }}
          class="flex items-center gap-3"
        >
          <input checked={operation.dynamic} type="radio" name="amount" value="DYNAMIC" class="h-5 w-5" />
          <span class="text-sm text-white">DYNAMIC</span>
        </button>
      </div>
      <!-- <button on:click={displayUploadSection} type="button" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-[#a0a1a580] bg-transparent p-0.5 transition-colors duration-200 ease-in-out focus:outline-none">
        <span class="inline-block h-4 w-4 {operation.dynamic ? 'translate-x-5' : 'translate-x-0'} transform rounded-full {operation.dynamic ? 'bg-green-500' : 'bg-yellow-500'} shadow ring-0 transition duration-200 ease-in-out" />
      </button> -->
    </div>
  {:else}
    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">VALUE</div>
      <input type="text" readonly bind:value={operation.value} class="w-full truncate rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none focus:ring-2 focus:ring-extraBlue-500" />
    </div>
  {/if}

  <div class="space-y-3">
    {#if operation.type == "image"}
      {#if operation.uploadImage}
        {#if loading}
          <div>
            <div class="flex h-32 cursor-pointer flex-col items-center justify-center gap-3 rounded-md border border-stone-700 bg-transparent">
              <div class="h-20 w-20 animate-spin rounded-full border-[1px] border-gray-300 border-r-blue-500" />
            </div>
          </div>
        {:else}
          <div class="relative flex h-32 cursor-pointer flex-col items-center gap-3 rounded-md border border-stone-700 bg-transparent">
            <form id="formImageEdit">
              <input bind:files type="file" name="userImage" class="absolute inset-0 cursor-pointer opacity-0" accept="image/*" />
            </form>
            <span class="text-xl text-gray-g00">
              <i class="fa-solid fa-image" />
            </span>
            <div class="flex flex-col items-center justify-center">
              <p class="text-sm text-white">
                Upload Image <span>or drag and drop</span>
              </p>
              <span class="select-none pt-2 text-center text-xs font-normal text-gray-g00">Maximum Size 2MB</span>
              <span class="pt-2 text-xs text-gray-g00">Choose jpeg, jpg, png files</span>
            </div>
          </div>
        {/if}
      {:else if !operation.uploadImage}
        <div class="flex h-32 w-full items-center gap-3">
          <div class="group relative flex w-2/5 items-center justify-center">
            <img src={operation.image.src} alt="StaticImage" class="aspect-auto max-h-[116px] max-w-full rounded-md" />
            <button
              type="button"
              on:click={async () => {
                if (!operation.dynamic) {
                  if (operation.width >= operation.height) operation.height = operation.width
                  else operation.width = operation.height
                }
                operation.src = drawChecked(operation.width, operation.height)
                operation.image = await loadImage(operation.src)
                operation.uploadImage = true
              }}
              class="absolute inset-0 hidden rounded-md bg-[#000000cc] text-2xl group-hover:block group-hover:text-red-500"
            >
              <i class="fa-solid fa-circle-xmark hover:text-red-400" />
            </button>
          </div>
          <div class="flex w-3/5 flex-col justify-center space-y-2 overflow-hidden">
            <h3 class="mt-1 truncate break-words text-sm font-bold text-white">
              {operation.dynamic ? "Dynamic Image" : operation.src.split("/")[2]}
            </h3>
            <div class="rounded-md text-xs font-bold text-gray-g00">
              {operation.width} x {operation.height}px
            </div>
          </div>
        </div>
      {/if}
    {/if}

    <div class="flex justify-between gap-3">
      <div class="group relative w-full rounded-md">
        {#if operation.errorX}
          <span class="absolute left-8 bottom-full mb-2 w-max rounded bg-yellow-400 px-2 py-1 text-black opacity-0 shadow transition group-hover:opacity-100">Fix this</span>
        {/if}
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 {operation.errorX ? 'group-focus-within:text-red-500' : 'group-focus-within:text-extraBlue-500'}">X</div>
        <button
          on:click={() => {
            operation.x = operation.x + 10
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click={() => {
            operation.x = operation.x - 10
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>
        <!-- on:wheel|preventDefault|stopPropagation={(e) => {
          if (e.deltaY < 0) {
            operation.x = operation.x + 10
          } else {
            operation.x = operation.x - 10
          }
        }} -->
        <input
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          min="1"
          max="100000"
          bind:value={operation.x}
          type="number"
          class="w-full rounded-md border {operation.errorX ? 'border-red-500 focus:ring-red-500 peer-focus:ring-red-500' : 'border-stone-700 focus:ring-extraBlue-500 peer-focus:ring-extraBlue-500'} bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-2 peer-focus:ring-2"
        />
      </div>
      <div class="group relative w-full rounded-md">
        {#if operation.errorY}
          <span class="absolute left-8 bottom-full mb-2 w-max rounded bg-yellow-400 px-2 py-1 text-black opacity-0 shadow transition group-hover:opacity-100">Fix this</span>
        {/if}
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 {operation.errorY ? 'group-focus-within:text-red-500' : 'group-focus-within:text-extraBlue-500'}">Y</div>
        <button
          on:click={() => {
            operation.y = operation.y - 10
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click={() => {
            operation.y = operation.y + 10
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>

        <input
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          min="0"
          max="100000"
          on:input={(e) => {
            operation.y = $fileTemplateState.baseImageInfo.height - operation.height - e.target.value
          }}
          on:keypress={preventKeys}
          bind:value={operation.inputY}
          id="yinput"
          type="number"
          class="w-full rounded-md border {operation.errorY ? 'border-red-500 focus:ring-red-500 peer-focus:ring-red-500' : 'border-stone-700 focus:ring-extraBlue-500 peer-focus:ring-extraBlue-500'} bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-2 peer-focus:ring-2"
        />
      </div>
      <button on:click={moveCursor} data-tooltip="Move" tooltip-position="top" class="flex items-center rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none focus:ring-2 focus:ring-extraBlue-500 active:bg-extraBlue-500">
        <span class="flex h-5 w-5 items-center justify-center">
          <i class="fa-solid fa-arrow-pointer" />
        </span>
      </button>
    </div>

    <!-- width height and link -->
    <div class="flex gap-3">
      <!-- width -->
      <div class="group relative w-full rounded-md">
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">W</div>
        <button
          on:click={async () => {
            const maxW = $fileTemplateState.baseImageInfo.width
            operation.width = Math.min(operation.width + 10, maxW)

            if (maintainAspectRatio && operation.width) {
              operation.height = Math.floor(operation.width / aspectRatio)
            }
            if (operation.uploadImage) {
              operation.src = drawChecked(operation.width, operation.height)
              operation.image = await loadImage(operation.src)
            }
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click={async () => {
            if (operation.width <= 10) {
              closeNotification.close()
              closeNotification = notify.info("The minimum allowed value is 10px")
              return
            }
            operation.width = Math.max(operation.width - 10, 10)
            if (maintainAspectRatio && operation.width) {
              operation.height = Math.floor(operation.width / aspectRatio)
            }
            if (operation.uploadImage) {
              operation.src = drawChecked(operation.width, operation.height)
              operation.image = await loadImage(operation.src)
            }
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>
        <!-- on:wheel|preventDefault|stopPropagation={(e) => {
          if (maintainAspectRatio && operation.width) {
            if (e.deltaY < 0) {
              operation.width = operation.width + 10
              operation.height = Math.floor(e.target.value / aspectRatio) + 10
            } else {
              operation.width = operation.width - 10
              operation.height = Math.floor(e.target.value / aspectRatio) - 10
            }
          } else {
            if (e.deltaY < 0) {
              operation.width = operation.width + 10
            } else {
              operation.width = operation.width - 10
            }
          }
        }} -->
        <!-- <input
          min="1"
          max="100000"
          on:input={async (e) => {
            if (maintainAspectRatio && e.target.value) {
              operation.height = Math.floor(e.target.value / aspectRatio)
            }
            operation.width = e.target.value
            if (operation.uploadImage) {
              operation.src = drawChecked(operation.width, operation.height)
              operation.image = await loadImage(operation.src)
            }
          }}
          bind:value={operation.width}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          type="number"
          class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-2 focus:ring-extraBlue-500 peer-focus:ring-2 peer-focus:ring-extraBlue-500"
        /> -->

        <input
          min="1"
          max="100000"
          value={operation.width}
          on:input={async (e) => {
            const raw = e.target.value
            if (!raw || Number(raw) <= 0) return

            operation.width = Number(raw)

            if (maintainAspectRatio) {
              operation.height = Math.floor(operation.width / aspectRatio)
            }

            if (operation.uploadImage) {
              operation.src = drawChecked(operation.width, operation.height)
              operation.image = await loadImage(operation.src)
            }
          }}
          on:blur={async (e) => {
            if (!e.target.value || Number(e.target.value) <= 0) {
              operation.width = Math.floor($fileTemplateState.baseImageInfo.width / 10)
              e.target.value = operation.width
              if (maintainAspectRatio) {
                operation.height = Math.floor(operation.width / aspectRatio)
              }
              if (operation.uploadImage) {
                operation.src = drawChecked(operation.width, operation.height)
                operation.image = await loadImage(operation.src)
              }
            }
          }}
          on:keydown={(e) => {
            if (e.key === "Delete") e.stopPropagation()
          }}
          on:keypress={preventKeys}
          type="number"
          placeholder="Width"
          class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-2 focus:ring-extraBlue-500 peer-focus:ring-2 peer-focus:ring-extraBlue-500"
        />
      </div>
      <!-- height -->
      <div class="group relative w-full rounded-md">
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">H</div>
        <button
          on:click={async () => {
            const maxH = $fileTemplateState.baseImageInfo.height
            operation.height = Math.min(operation.height + 10, maxH)
            if (maintainAspectRatio && operation.height) {
              operation.width = Math.floor(aspectRatio * operation.height)
            }
            if (operation.uploadImage) {
              operation.src = drawChecked(operation.width, operation.height)
              operation.image = await loadImage(operation.src)
            }
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click={async () => {
            if (operation.height <= 10) {
              closeNotification.close()
              closeNotification = notify.info("The minimum allowed value is 10px")
              return
            }
            operation.height = Math.max(operation.height - 10, 10)
            if (maintainAspectRatio && operation.height) {
              operation.width = Math.floor(aspectRatio * operation.height)
            }
            if (operation.uploadImage) {
              operation.src = drawChecked(operation.width, operation.height)
              operation.image = await loadImage(operation.src)
            }
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>
        <!-- <input
          min="1"
          max="100000"
          on:input={async (e) => {
            if (maintainAspectRatio && e.target.value) {
              operation.width = Math.floor(aspectRatio * e.target.value)
            }
            operation.height = e.target.value
            if (operation.uploadImage) {
              operation.src = drawChecked(operation.width, operation.height)
              operation.image = await loadImage(operation.src)
            }
          }}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          bind:value={operation.height}
          type="number"
          class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-2 focus:ring-extraBlue-500 peer-focus:ring-2 peer-focus:ring-extraBlue-500"
        /> -->

        <input
          min="1"
          max="100000"
          value={operation.height}
          on:input={async (e) => {
            const raw = e.target.value
            if (!raw || Number(raw) <= 0) return

            operation.height = Number(raw)

            if (maintainAspectRatio) {
              operation.width = Math.floor(operation.height * aspectRatio)
            }

            if (operation.uploadImage) {
              operation.src = drawChecked(operation.width, operation.height)
              operation.image = await loadImage(operation.src)
            }
          }}
          on:blur={async (e) => {
            if (!e.target.value || Number(e.target.value) <= 0) {
              operation.height = Math.floor($fileTemplateState.baseImageInfo.height / 10)
              e.target.value = operation.height
              if (maintainAspectRatio) {
                operation.width = Math.floor(operation.height * aspectRatio)
              }
              if (operation.uploadImage) {
                operation.src = drawChecked(operation.width, operation.height)
                operation.image = await loadImage(operation.src)
              }
            }
          }}
          on:keydown={(e) => {
            if (e.key === "Delete") e.stopPropagation()
          }}
          on:keypress={preventKeys}
          type="number"
          placeholder="Height"
          class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-2 focus:ring-extraBlue-500 peer-focus:ring-2 peer-focus:ring-extraBlue-500"
        />

        <!-- on:wheel|preventDefault|stopPropagation={(e) => {
          if (maintainAspectRatio && e.target.value) {
            if (e.deltaY < 0) {
              operation.height = operation.height + 10
              operation.width = Math.floor(aspectRatio * e.target.value) + 10
            } else {
              operation.height = operation.height - 10
              operation.width = Math.floor(aspectRatio * e.target.value) - 10
            }
          } else {
            if (e.deltaY < 0) {
              operation.height = operation.height + 10
            } else {
              operation.height = operation.height - 10
            }
          }
        }} -->
      </div>
      <!-- link button -->
      <button
        disabled={operation.type == "qr"}
        on:click={() => {
          if (operation.uploadImage) {
            aspectRatio = operation.width / operation.height
          }
          maintainAspectRatio = !maintainAspectRatio
        }}
        data-tooltip="Use Original Aspect Ratio"
        tooltip-position="left"
        class="{maintainAspectRatio ? 'bg-blue-500 text-white' : 'bg-transparent text-gray-g00'} flex items-center rounded-md border border-stone-700 p-2 text-lg hover:bg-zinc-900 focus:outline-none focus:ring-2 focus:ring-extraBlue-500 active:bg-extraBlue-500 disabled:cursor-not-allowed"
      >
        <span class="flex h-5 w-5 items-center justify-center">
          <i class="fa-solid fa-link-simple" />
        </span>
      </button>
    </div>
    {#if operation.type == "qr"}
      <div class="flex items-center gap-3">
        <!-- <div>
          <span class="text-sm font-semibold uppercase text-gray-500">QR code</span> -->
        <div class="flex">
          <button
            data-tooltip="Transparent"
            tooltip-position="top"
            on:click={async () => {
              if (operation.bgColor == "#0000") {
                invalidNotification.close()
                const info = "PAGE: File template editor\n EVENT: While applying transparent color to QR foreground"
                invalidNotification = notify.danger("Cannot set QR code as transparent because the QR code background itself is transparent.", info)
              } else {
                operation.color = "#0000"
                await generateQR()
              }
            }}
            class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-l border border-gray-700 disabled:cursor-not-allowed"
          >
            <i class="fa-solid fa-droplet-slash text-slate-500" />
          </button>

          <div class="relative flex">
            <div style="background:{operation.color}" class="h-8 w-8 border border-gray-700" />

            <div data-tooltip="Color" tooltip-position="top" class="relative flex h-8 w-8 items-center justify-center rounded-r border-y border-r border-gray-700">
              <i class="fa-solid fa-qrcode text-slate-500" />
            </div>
            <input
              on:input={async (e) => {
                if (e.target.value == operation.bgColor) {
                  invalidNotification.close()
                  const info = "PAGE: File template editor\n EVENT: While applying transparent color to QR foreground through input"
                  invalidNotification = notify.danger("Cannot set the QR code background and color to be the same.", info)
                  operation.color = operation.bgColor == "#000000" ? "#ffffff" : "#000000"
                } else {
                  operation.color = e.target.value
                }
                await generateQR()
              }}
              bind:value={operation.color}
              type="color"
              class="absolute inset-0 h-full w-full cursor-pointer opacity-0"
            />
          </div>
        </div>
        <!-- </div> -->
        <!-- <div>
          <span class="text-sm font-semibold uppercase text-gray-500">Background</span> -->
        <div class="flex">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <button
            data-tooltip="Transparent"
            tooltip-position="top"
            on:click={async () => {
              if (operation.color == "#0000") {
                // notify.danger("choose only one transparent")
                invalidNotification.close()
                const info = "PAGE: File template editor\n EVENT: While applying transparent color to QR background"
                invalidNotification = notify.danger("Cannot set QR code background as transparent because the QR code itself is transparent.", info)
              } else {
                operation.bgColor = "#0000"
                await generateQR()
              }
            }}
            class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-l border border-gray-700 disabled:cursor-not-allowed"
          >
            <i class="fa-solid fa-droplet-slash text-slate-500" />
          </button>

          <div class="relative flex">
            <div style="background:{operation.bgColor}" class="h-8 w-8 border border-gray-700" />
            <div data-tooltip="Background color" tooltip-position="top" class=" flex h-8 w-8 items-center justify-center rounded-r border-y border-r border-gray-700">
              <i class="fa-solid fa-square-full text-slate-500" />
            </div>
            <input
              on:input={async (e) => {
                if (e.target.value == operation.color) {
                  invalidNotification.close()
                  const info = "PAGE: File template editor\n EVENT: While applying transparent color to QR background through input"
                  invalidNotification = notify.danger("Cannot set the QR code background and color to be the same.", info)
                  operation.bgColor = operation.color == "#000000" ? "#ffffff" : "#000000"
                } else {
                  operation.bgColor = e.target.value
                }
                await generateQR()
              }}
              bind:value={operation.bgColor}
              type="color"
              class="absolute inset-0 h-full w-full cursor-pointer opacity-0"
            />
          </div>
        </div>
        <!-- </div> -->
      </div>
    {/if}
  </div>
</div>
